import template from './notification_management.create.html';
import controller from './notification_management.create.controller';
import './notification_management.create.scss';

let NotificationManagementCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default NotificationManagementCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/create/notification_management.create.component.js